import React from "react";

import TalkModifyPost from "../../../components/Talk/ModifyPost";

type Props = {};

// eslint-disable-next-line no-empty-pattern
export default function TalkNewPost(props: Props) {
  return <TalkModifyPost />;
}
